export const DEMO_BLOCKED_ROUTES = [
  'deposit',
  'withdraw',
  'loan',
  'nfts',
  'invite',
  'identity',
  'lendingPools',
  'lendingPoolDetail'
]

export const DEMO_BLOCKED_MENU_KEYS = [
  'nfts',
  'deposit',
  'withdraw',
  'lendingPools',
  'loan',
  'identity',
  'pin',
  'invite'
]

export function isDemoAccount(userInfo, virtualStatus) {
  if (userInfo && Number(userInfo.userType) === 2) return true
  return Number(virtualStatus) === 2
}

export function resolveVirtualStatus(userInfo, fallback) {
  if (userInfo && userInfo.userType != null) {
    return Number(userInfo.userType) === 2 ? 2 : 1
  }
  return Number(fallback) === 2 ? 2 : 1
}
